export default __webpack_public_path__ + "line-chart-light.9557be84.svg";